import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import {
  MasterKey,
  MasterSearchParam,
  PersonalInfoAgreeGetResult,
  SettingsGetResult,
} from '../../models/gen/models';
import { useGenericMutation } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';
import { MasterSearchResult } from './master';

const apis = apiGenerator();

export const useInitialFetching = () =>
  useGenericMutation(async () =>
    Promise.all([
      apis.get<void, PersonalInfoAgreeGetResult>(
        `${
          env.BASE_API_ENDPOINT
        }/worker/personal-info/agree?${new Date().getTime()}`,
        { ...queryOptions }
      ),
      apis.get<void, SettingsGetResult>(
        `${env.BASE_API_ENDPOINT}/facility-settings`,
        { ...queryOptions }
      ),
      apis.post<MasterSearchParam, MasterSearchResult>(
        `${env.BASE_API_ENDPOINT}/master/search`,
        {
          ...queryOptions,
          data: {
            keys: [
              MasterKey.ApplyUnits,
              MasterKey.AttendanceTypes,
              MasterKey.ExpenseItems,
              MasterKey.ExtraFees,
              MasterKey.NoticeCategories,
              MasterKey.Offices,
              MasterKey.Roles,
              MasterKey.Tasks,
            ],
          },
        }
      ),
    ])
  );
